<template>
  <div>
    <HeaderControls :myWeek='false' @collapseToggleUpdated='collapseToggleUpdate' />
    <div class="deliverable-main container-fluid">
      <SocialScheduleCalendar v-if="systemSettingsReady" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate' />
      <!--<SocialScheduleCalendar v-if="$store.getters.systemSettings.publish_statuses" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate' />-->
    </div>
  </div>
</template>
<script>
import SocialScheduleCalendar from "../components/deliverables/SocialScheduleCalendar";
import HeaderControls from "../components/common/HeaderControlsSocial";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      expandAll: !this.isMobile(),
      systemSettingsReady: false,
    }
  },
  computed: {
    ...mapGetters(["allCustomFields", 'allUsers', 'systemSettings']),
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    SocialScheduleCalendar,
    HeaderControls
  },
  methods: {
    ...mapActions([
			"fetchSystemSettings",
		]),
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    },
    checkSystemSettingsReady(){
      if(this.systemSettings.publish_statuses){
        this.systemSettingsReady = true;
      } else {
        this.systemSettingsReady = false;
      }
    },
  },
  mounted(){
    document.body.classList.add("social-media");
  },
  created(){
    this.fetchSystemSettings();

    this.checkSystemSettingsReady();
  },
  watch:{
		systemSettings (to, from){
			console.log("systemSettings changed");
      this.checkSystemSettingsReady();
		}
	}
}
</script>
